import { createVNode as _createVNode, createTextVNode as _createTextVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createBlock as _createBlock, resolveComponent as _resolveComponent, withCtx as _withCtx, toDisplayString as _toDisplayString, createCommentVNode as _createCommentVNode, resolveDirective as _resolveDirective, withDirectives as _withDirectives, withScopeId as _withScopeId, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
const _withId = /*#__PURE__*/_withScopeId("data-v-21e97a8a")

_pushScopeId("data-v-21e97a8a")
const _hoisted_1 = { class: "performanceOverview" }
const _hoisted_2 = { class: "performanceDataDetails" }
const _hoisted_3 = /*#__PURE__*/_createVNode("h5", { class: "TitleStyle" }, [
  /*#__PURE__*/_createVNode("span"),
  /*#__PURE__*/_createTextVNode("最近测试记录    ")
], -1)
const _hoisted_4 = { class: "spacName2" }
const _hoisted_5 = /*#__PURE__*/_createTextVNode("全部清空")
const _hoisted_6 = {
  key: 1,
  style: {"color":"#c0c4cc"}
}
const _hoisted_7 = {
  key: 1,
  style: {"color":"#c0c4cc"}
}
const _hoisted_8 = { class: "dialogForm" }
const _hoisted_9 = { class: "dialogTitle" }
const _hoisted_10 = /*#__PURE__*/_createVNode("span", null, "上传性能数据", -1)
const _hoisted_11 = /*#__PURE__*/_createVNode("i", { class: "el-icon-upload" }, null, -1)
const _hoisted_12 = /*#__PURE__*/_createVNode("div", { class: "el-upload__text" }, [
  /*#__PURE__*/_createTextVNode(" 将文件拖到此处，或 "),
  /*#__PURE__*/_createVNode("em", null, "点击上传")
], -1)
const _hoisted_13 = /*#__PURE__*/_createVNode("div", { class: "el-upload__tip" }, " 只能上传zip文件，且不超过500MB ", -1)
const _hoisted_14 = { class: "dialog-footer" }
const _hoisted_15 = /*#__PURE__*/_createTextVNode("重 置")
const _hoisted_16 = /*#__PURE__*/_createTextVNode("确 定")
_popScopeId()

export const render = /*#__PURE__*/_withId((_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) => {
  const _component_el_option = _resolveComponent("el-option")
  const _component_el_select = _resolveComponent("el-select")
  const _component_el_form_item = _resolveComponent("el-form-item")
  const _component_el_button = _resolveComponent("el-button")
  const _component_el_form = _resolveComponent("el-form")
  const _component_el_table_column = _resolveComponent("el-table-column")
  const _component_el_checkbox = _resolveComponent("el-checkbox")
  const _component_el_table = _resolveComponent("el-table")
  const _component_el_input = _resolveComponent("el-input")
  const _component_el_pagination = _resolveComponent("el-pagination")
  const _component_el_card = _resolveComponent("el-card")
  const _component_el_divider = _resolveComponent("el-divider")
  const _component_el_upload = _resolveComponent("el-upload")
  const _component_el_dialog = _resolveComponent("el-dialog")
  const _component_el_main = _resolveComponent("el-main")
  const _component_el_container = _resolveComponent("el-container")
  const _directive_loading = _resolveDirective("loading")

  return (_openBlock(), _createBlock(_component_el_container, null, {
    default: _withId(() => [
      _createVNode(_component_el_container, null, {
        default: _withId(() => [
          _createVNode(_component_el_main, null, {
            default: _withId(() => [
              _createVNode("div", _hoisted_1, [
                _createVNode("div", _hoisted_2, [
                  _hoisted_3,
                  _createVNode("div", _hoisted_4, [
                    _createVNode(_component_el_card, null, {
                      default: _withId(() => [
                        _createVNode(_component_el_form, {
                          class: "spacForm",
                          size: "mini",
                          inline: true
                        }, {
                          default: _withId(() => [
                            _createVNode(_component_el_form_item, { label: "选择场景" }, {
                              default: _withId(() => [
                                _createVNode(_component_el_select, {
                                  modelValue: _ctx.selected_table_scene,
                                  "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => (_ctx.selected_table_scene = $event)),
                                  placeholder: "请选择场景",
                                  clearable: "",
                                  filterable: "",
                                  onChange: _cache[2] || (_cache[2] = ($event: any) => (_ctx.selectTableChange('Search')))
                                }, {
                                  default: _withId(() => [
                                    (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.scene_options, (item) => {
                                      return (_openBlock(), _createBlock(_component_el_option, {
                                        key: item.scene_id,
                                        label: item.chinese,
                                        value: item.scene_id
                                      }, null, 8, ["label", "value"]))
                                    }), 128))
                                  ]),
                                  _: 1
                                }, 8, ["modelValue"])
                              ]),
                              _: 1
                            }),
                            _createVNode(_component_el_form_item, { label: "选择机型" }, {
                              default: _withId(() => [
                                _createVNode(_component_el_select, {
                                  modelValue: _ctx.selected_table_device,
                                  "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => (_ctx.selected_table_device = $event)),
                                  placeholder: "请选择机型",
                                  clearable: "",
                                  filterable: "",
                                  onChange: _cache[4] || (_cache[4] = ($event: any) => (_ctx.selectTableChange('Search')))
                                }, {
                                  default: _withId(() => [
                                    (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.device_options, (item) => {
                                      return (_openBlock(), _createBlock(_component_el_option, {
                                        key: item.device_id,
                                        label: item.device_name,
                                        value: item.device_id
                                      }, null, 8, ["label", "value"]))
                                    }), 128))
                                  ]),
                                  _: 1
                                }, 8, ["modelValue"])
                              ]),
                              _: 1
                            }),
                            _createVNode(_component_el_form_item, null, {
                              default: _withId(() => [
                                _createVNode(_component_el_button, {
                                  type: "primary",
                                  onClick: _cache[5] || (_cache[5] = ($event: any) => (_ctx.onTableClear()))
                                }, {
                                  default: _withId(() => [
                                    _hoisted_5
                                  ]),
                                  _: 1
                                })
                              ]),
                              _: 1
                            }),
                            _createVNode(_component_el_form_item, null, {
                              default: _withId(() => [
                                _createVNode("i", {
                                  class: "upload_deep",
                                  style: _ctx.get_is_super ? 'visibility: hidden' : '',
                                  onClick: _cache[6] || (_cache[6] = ($event: any) => (_ctx.submitUpload('open')))
                                }, "上传性能数据 ", 4)
                              ]),
                              _: 1
                            })
                          ]),
                          _: 1
                        }),
                        _withDirectives(_createVNode(_component_el_table, {
                          onSelectAll: _ctx.handleSelect,
                          data: _ctx.get_all_performance,
                          ref: "dataTable",
                          "header-cell-class-name": "tabelHeader"
                        }, {
                          default: _withId(() => [
                            _createVNode(_component_el_table_column, {
                              index: _ctx.indexMethod(0),
                              type: "index",
                              label: "序号",
                              width: "60"
                            }, null, 8, ["index"]),
                            (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.PerfFields, (item, index) => {
                              return (_openBlock(), _createBlock(_component_el_table_column, {
                                key: item.label,
                                index: index,
                                width: item.width,
                                label: item.label,
                                prop: item.prop,
                                title: item.prop
                              }, null, 8, ["index", "width", "label", "prop", "title"]))
                            }), 128)),
                            _createVNode(_component_el_table_column, {
                              label: "状态",
                              width: "100"
                            }, {
                              default: _withId((scope) => [
                                _createVNode("span", {
                                  style: 'color:' + _ctx.statusShow(scope.row.status)[1]
                                }, _toDisplayString(_ctx.statusShow(scope.row.status)[0]), 5)
                              ]),
                              _: 1
                            }),
                            _createVNode(_component_el_table_column, {
                              label: "操作",
                              width: "100"
                            }, {
                              default: _withId((scope) => [
                                (scope.row.status == 4)
                                  ? (_openBlock(), _createBlock("span", {
                                      key: 0,
                                      onClick: ($event: any) => (_ctx.retry(scope.row.id)),
                                      style: {"cursor":"pointer","color":"#61c3e4"}
                                    }, "重试", 8, ["onClick"]))
                                  : (_openBlock(), _createBlock("span", _hoisted_6, "重试"))
                              ]),
                              _: 1
                            }),
                            _createVNode(_component_el_table_column, {
                              label: "有效",
                              width: "60"
                            }, {
                              default: _withId((scope) => [
                                _createVNode(_component_el_checkbox, {
                                  onChange: ($event: any) => (_ctx.checkChange(scope.row)),
                                  modelValue: scope.row.valid,
                                  "onUpdate:modelValue": ($event: any) => (scope.row.valid = $event)
                                }, null, 8, ["onChange", "modelValue", "onUpdate:modelValue"])
                              ]),
                              _: 1
                            }),
                            _createVNode(_component_el_table_column, {
                              label: "下载",
                              width: "60"
                            }, {
                              default: _withId((scope) => [
                                (_ctx.statusShow(scope.row.status)[2])
                                  ? (_openBlock(), _createBlock("a", {
                                      key: 0,
                                      href: _ctx.los(scope.row.id),
                                      download: "",
                                      style: {"cursor":"pointer","color":"#61c3e4","text-decoration":"none"}
                                    }, "下载", 8, ["href"]))
                                  : (_openBlock(), _createBlock("span", _hoisted_7, "下载"))
                              ]),
                              _: 1
                            })
                          ]),
                          _: 1
                        }, 8, ["onSelectAll", "data"]), [
                          [_directive_loading, _ctx.loading]
                        ]),
                        _createVNode(_component_el_form, {
                          inline: true,
                          size: "mini",
                          class: "pagingStyle"
                        }, {
                          default: _withId(() => [
                            _createVNode(_component_el_form_item, { label: "每页" }, {
                              default: _withId(() => [
                                _createVNode(_component_el_input, {
                                  modelValue: _ctx.record,
                                  "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => (_ctx.record = $event)),
                                  style: {"width":"50px"},
                                  onChange: _cache[8] || (_cache[8] = ($event: any) => (_ctx.selectTableChange('paging')))
                                }, null, 8, ["modelValue"])
                              ]),
                              _: 1
                            }),
                            _createVNode(_component_el_form_item, { label: "条记录" }),
                            _createVNode(_component_el_form_item, null, {
                              default: _withId(() => [
                                _createVNode(_component_el_pagination, {
                                  onCurrentChange: _cache[9] || (_cache[9] = ($event: any) => (_ctx.selectTableChange('paging'))),
                                  currentPage: _ctx.current_page,
                                  "onUpdate:currentPage": _cache[10] || (_cache[10] = ($event: any) => (_ctx.current_page = $event)),
                                  "page-size": _ctx.record,
                                  layout: "total, prev, pager, next, jumper",
                                  total: _ctx.readPerformancePageList.count
                                }, null, 8, ["currentPage", "page-size", "total"])
                              ]),
                              _: 1
                            })
                          ]),
                          _: 1
                        })
                      ]),
                      _: 1
                    })
                  ])
                ]),
                _createVNode("div", _hoisted_8, [
                  _createVNode(_component_el_dialog, {
                    modelValue: _ctx.dialogVisible,
                    "onUpdate:modelValue": _cache[17] || (_cache[17] = ($event: any) => (_ctx.dialogVisible = $event)),
                    width: "30%",
                    onClose: _cache[18] || (_cache[18] = ($event: any) => (_ctx.dialogVisible = false))
                  }, {
                    title: _withId(() => [
                      _createVNode("div", _hoisted_9, [
                        _hoisted_10,
                        _createVNode(_component_el_divider)
                      ])
                    ]),
                    footer: _withId(() => [
                      _createVNode("span", _hoisted_14, [
                        _createVNode(_component_el_button, {
                          size: "small",
                          onClick: _cache[15] || (_cache[15] = ($event: any) => (_ctx.submitUpload('no')))
                        }, {
                          default: _withId(() => [
                            _hoisted_15
                          ]),
                          _: 1
                        }),
                        _createVNode(_component_el_button, {
                          size: "small",
                          type: "primary",
                          onClick: _cache[16] || (_cache[16] = ($event: any) => (_ctx.submitUpload('ok')))
                        }, {
                          default: _withId(() => [
                            _hoisted_16
                          ]),
                          _: 1
                        })
                      ])
                    ]),
                    default: _withId(() => [
                      _createVNode(_component_el_form, {
                        inline: true,
                        model: _ctx.dialogForm,
                        size: "small",
                        "label-position": "top"
                      }, {
                        default: _withId(() => [
                          _createVNode(_component_el_form_item, { label: "地图" }, {
                            default: _withId(() => [
                              _createVNode(_component_el_select, {
                                modelValue: _ctx.dialogForm.scene_id,
                                "onUpdate:modelValue": _cache[11] || (_cache[11] = ($event: any) => (_ctx.dialogForm.scene_id = $event)),
                                placeholder: "请选择地图"
                              }, {
                                default: _withId(() => [
                                  (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.getScenes, (item) => {
                                    return (_openBlock(), _createBlock(_component_el_option, {
                                      key: item.id,
                                      label: item.chinese,
                                      value: item.id
                                    }, null, 8, ["label", "value"]))
                                  }), 128))
                                ]),
                                _: 1
                              }, 8, ["modelValue"])
                            ]),
                            _: 1
                          }),
                          _createVNode(_component_el_form_item, { label: "设备" }, {
                            default: _withId(() => [
                              _createVNode(_component_el_select, {
                                modelValue: _ctx.dialogForm.UUID,
                                "onUpdate:modelValue": _cache[12] || (_cache[12] = ($event: any) => (_ctx.dialogForm.UUID = $event)),
                                placeholder: "请选择设备"
                              }, {
                                default: _withId(() => [
                                  (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.DeviceSpecs, (item, index) => {
                                    return (_openBlock(), _createBlock(_component_el_option, {
                                      key: index,
                                      label: 
                        item.model.name +
                        ' (' +
                        item.model.model +
                        ') - ' +
                        item.UUID
                      ,
                                      value: item.UUID,
                                      title: 
                        item.model.name +
                        ' (' +
                        item.model.model +
                        ') - ' +
                        item.UUID
                      
                                    }, null, 8, ["label", "value", "title"]))
                                  }), 128))
                                ]),
                                _: 1
                              }, 8, ["modelValue"])
                            ]),
                            _: 1
                          }),
                          _createVNode(_component_el_form_item, { label: "场景脚本" }, {
                            default: _withId(() => [
                              _createVNode(_component_el_select, {
                                modelValue: _ctx.dialogForm.script_id,
                                "onUpdate:modelValue": _cache[13] || (_cache[13] = ($event: any) => (_ctx.dialogForm.script_id = $event)),
                                placeholder: "请选择场景脚本"
                              }, {
                                default: _withId(() => [
                                  (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.getScripts(_ctx.dialogForm.scene_id), (script) => {
                                    return (_openBlock(), _createBlock(_component_el_option, {
                                      key: script.script_id,
                                      label: script.script_name,
                                      value: script.script_id
                                    }, null, 8, ["label", "value"]))
                                  }), 128))
                                ]),
                                _: 1
                              }, 8, ["modelValue"])
                            ]),
                            _: 1
                          })
                        ]),
                        _: 1
                      }, 8, ["model"]),
                      _createVNode(_component_el_form, {
                        model: _ctx.dialogForm,
                        size: "small",
                        "label-position": "top"
                      }, {
                        default: _withId(() => [
                          _createVNode(_component_el_form_item, { label: "上传文件" }, {
                            default: _withId(() => [
                              _createVNode(_component_el_upload, {
                                class: "upload-demo",
                                drag: "",
                                action: "http://127.0.0.1:8081/api/v1/deep_performance/flame_graph_upload/",
                                multiple: "",
                                limit: 1,
                                "before-upload": _ctx.beforeUpload,
                                ref: 'upload',
                                "http-request": _ctx.UploadFile
                              }, {
                                tip: _withId(() => [
                                  _hoisted_13
                                ]),
                                default: _withId(() => [
                                  _hoisted_11,
                                  _hoisted_12
                                ]),
                                _: 1
                              }, 8, ["before-upload", "http-request"])
                            ]),
                            _: 1
                          }),
                          _createVNode(_component_el_form_item, { label: "测试版本" }, {
                            default: _withId(() => [
                              _createVNode(_component_el_input, {
                                style: {"width":"250px"},
                                modelValue: _ctx.dialogForm.game_version,
                                "onUpdate:modelValue": _cache[14] || (_cache[14] = ($event: any) => (_ctx.dialogForm.game_version = $event)),
                                placeholder: "请输入"
                              }, null, 8, ["modelValue"])
                            ]),
                            _: 1
                          })
                        ]),
                        _: 1
                      }, 8, ["model"])
                    ]),
                    _: 1
                  }, 8, ["modelValue"])
                ])
              ])
            ]),
            _: 1
          })
        ]),
        _: 1
      })
    ]),
    _: 1
  }))
})